import request from "./request";

// 提交订单
export function submitOrder(data) {
  return request({
    url: "/api/h5/Order/submitOrder",
    method: "post",
    data,
  });
}

// 参数解密
export function decryptParam(data) {
  return request({
    url: "/api/h5/Order/decryptParam",
    method: "post",
    data,
  });
}

// 获取数据字典
export function DictionaryData(typeId) {
  return request({
    url: `/api/system/Base/DictionaryData/${typeId}`,
    method: "get",
  });
}

// 通过门店代码获取门店信息
export function storeInfo(storeCode) {
  return request({
    url: `/api/h5/Order/storeInfo/${storeCode}`,
    method: "get",
  });
}

// 微信授权 - 通过code获取用户信息
export function getWechatUserInfo(code) {
  return request({
    url: "/api/h5/Wechat/getUserInfo",
    method: "post",
    data: { code },
  });
}

// 微信授权 - 获取access_token
export function getWechatAccessToken(code) {
  return request({
    url: "/api/h5/Wechat/getAccessToken",
    method: "post",
    data: { code },
  });
}

// 微信OAuth2授权 - 获取access_token并保存code
export function getWxOauth2AccessToken(code) {
  return request({
    url: "/api/oauth/getWxOauth2AccessToken",
    method: "get",
    params: { code },
  });
}
